module.exports = __webpack_public_path__ + "img/ics_o_print_red.5d35b463.svg";